import api from './api.js';
const BASE_URL = '/api_7392ec370066ba93/';


export const getSalonInfo = (params) => api({
    url: `${BASE_URL}webapi:salon:index`, // 使用全局变量拼接路径
    method: 'get',
    // headers: {
    //     'content-type': 'application/x-www-form-urlencoded',
    // },
    params: params
})

export const submitApplication = (data) => api({
    url: `${BASE_URL}webapi:salon:application`, // 使用全局变量拼接路径
    method: 'post',
    headers: {
        'content-type': 'application/x-www-form-urlencoded',
    },
    data: data
})

export const getApplicationDetail = (params) => api({
    url: `${BASE_URL}webapi:salon:detail`, // 使用全局变量拼接路径
    method: 'get',
    headers: {
        'content-type': 'application/x-www-form-urlencoded',
    },
    params: params
})

